import domReady from '@wordpress/dom-ready';

domReady(() => {
  const alphaFilterBtn = document.querySelector('#alphaFilterBtn');
  const alphaFilter = document.querySelector('.facet-filter-alpha');

  if (alphaFilterBtn && alphaFilter) {
    alphaFilterBtn.addEventListener('click', () => {
      alphaFilter.classList.toggle('alphaFiltervisible');
      alphaFilterBtn.classList.toggle('alphaFilterOpen');
    });
  }

  document.querySelectorAll('.facet-reset').forEach((resetBtn) => {
    resetBtn.addEventListener('click', () => {
      if (window.FWP) {
        window.FWP.reset();
      }
    });
  });
});
